import type { FulfillmentSettingsSummary, SchedulePresetInput } from '@flux/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { JSX } from 'react';
import { PageSection } from '@/components/layout/page.js';
import { Switch } from '@/components/ui/switch.js';
import { toast } from '@/lib/toast.js';
import { fulfillmentQueryKeys, updateFulfillmentEnabled, updateFulfillmentSchedule } from './api-martelet.js';
import { ScheduleEditor } from './schedule-editor.js';

export function MarteletTrackingSection({ settings }: { settings: FulfillmentSettingsSummary }): JSX.Element {
  const queryClient = useQueryClient();
  const invalidate = (): void => { void queryClient.invalidateQueries({ queryKey: fulfillmentQueryKeys.all }); };
  const enabled = useMutation({
    mutationFn: updateFulfillmentEnabled,
    onSuccess: () => { toast.success('Suivi Martelet mis à jour.'); invalidate(); },
    onError: (error: unknown) => toast.fromError(error),
  });
  const schedule = useMutation({
    mutationFn: updateFulfillmentSchedule,
    onSuccess: () => { toast.success('Planification mise à jour.'); invalidate(); },
    onError: (error: unknown) => toast.fromError(error),
  });
  return (
    <PageSection title="Suivi Martelet" description="Récupère les retours Martelet et met à jour les commandes Shopify lorsque le canal est actif.">
      <div className="flex flex-col gap-5">
        <label className="flex items-center gap-3 text-sm font-medium">
          <Switch checked={settings.enabled !== false} disabled={enabled.isPending} onCheckedChange={(value) => enabled.mutate(value)} />
          Canal {settings.enabled === false ? 'inactif' : 'actif'}
        </label>
        <div className="border-t border-border pt-5">
          <ScheduleEditor description={settings.scheduleDescription} cron={settings.schedule} nextRuns={settings.nextRuns}
            isSaving={schedule.isPending} onSaveCron={(cron) => schedule.mutate({ schedule: cron })}
            onSavePreset={(preset: SchedulePresetInput) => schedule.mutate({ preset })} />
        </div>
      </div>
    </PageSection>
  );
}
